export default () => {
    (($) => {
        $('.about-team-content-owners-owner-description-text-more-button').click(function() {
            let button = $(this);
            button.toggleClass('active');

            if (button.hasClass('active')) {
                button.attr('data-text-more', button.text());
                button.text(button.attr('data-text-less'));
            }
            else {
                button.text(button.attr('data-text-more'));
            }

            let content = button.siblings('.about-team-content-owners-owner-description-text-more-content');
            content.slideToggle();
        });
    })(jQuery);
}
